export function devicecheck() {
	if (window.navigator.userAgent.indexOf("Mac") != -1)
	{
		document.querySelector("html").classList.add("ios-device");
	}
}